// extracted by mini-css-extract-plugin
export default {"container":"LinkPage_container__4Ri98","sidebar":"LinkPage_sidebar__kvn8U","chatButton":"LinkPage_chatButton__64Gsu"};